import cookies from '@utils/cookies';
import { playerTypes } from '../constants';

const initialState = {
  isPlayerOpen: false,
  playerLoaded: false,
  unLiveURL: '',
  testEvalURL: '',
  urlMismatch: false,
  classData: {
    loading: false,
    loaded: false,
    data: null
  },
  showReferralDialog: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case playerTypes.CLOSE_PLAYER:
      return {
        ...state,
        isPlayerOpen: false
      };

    case playerTypes.TOGGLE_URL_MISMATCH:
      return {
        ...state,
        urlMismatch: action.urlMismatch
      };

    case playerTypes.OPEN_PLAYER:
      return {
        ...state,
        isPlayerOpen: true
      };

    case `${playerTypes.SET_PLAYER_URL}_SUCCESS`:
      return {
        ...state,
        unLiveURL: action.result.unlive_url,
        testEvalURL: action.result.subjective_test_series_url,
        liveRoomRecordingUrl: action.result.live_room_recording_url
      };

    case `${playerTypes.SET_OBJECT_TYPE}_SUCCESS`:
      return {
        ...state,
        doubtSolvingObjectType: action.result.doubts_solution
      };

    case playerTypes.SET_PLAYER_LOADED:
      return {
        ...state,
        playerLoaded: true
      };
    case playerTypes.RESET_PLAYER_LOADED:
      return {
        ...state,
        playerLoaded: false
      };

    case `${playerTypes.FETCH_CLASS}_REQUEST`:
      return {
        ...state,
        isPlayerOpen: false,
        classData: {
          loading: true,
          loaded: false,
          data: null
        }
      };

    case `${playerTypes.FETCH_CLASS}_SUCCESS`:
      return {
        ...state,
        isPlayerOpen: true,
        classData: {
          loading: false,
          loaded: true,
          data: action.result
        }
      };

    case `${playerTypes.SET_SHOW_REFERRAL}`:
      // eslint-disable-next-line no-case-declarations
      const showDialog =
        !cookies.readCookie('referral-player') ||
        Math.round(
          (new Date() -
            new Date(Number(cookies.readCookie('referral-player')))) /
            (1000 * 3600 * 24)
        ) > 7;
      return {
        ...state,
        showReferralDialog: action.classUID
          ? localStorage.getItem(`liveSessions[${action.classUID.current}]`) >
              1800 && showDialog
          : null
      };

    default:
      return state;
  }
};

export default reducer;
